import { Environment } from '@flywire/internal-components/model';

import {
  buildAttributes,
  initializeTracing
} from '../../internal-components/src/utils/otelTracing';
import { ElementFactory } from './api/elements/ElementFactory';
import { validateElementOptions } from './api/elements/optionsValidator';
import { SDKError } from './api/error';
import { validateFrontendApiKey } from './frontendKeyValidator';
import { SdkElementFactoryOptions } from './model';

declare const ENVIRONMENT: Environment;

const start = async (frontendKey: string) => {
  window.FLYWIRE_FE_KEY = frontendKey;

  initializeTracing({
    serviceName: 'flywire-js-sdk',
    env: ENVIRONMENT,
    attributes: buildAttributes({ frontend_key: frontendKey })
  });

  const isValid = await validateFrontendApiKey(frontendKey);
  if (!isValid) {
    throw new SDKError('invalidApiKey');
  }

  return {
    elements: async (options?: SdkElementFactoryOptions) => {
      return ElementFactory(await validateElementOptions(options));
    }
  };
};
export const Flywire = start;
